export const checkIsCMSPreviewMode = (props) => {
    return props.siteConfig.preview;
};
